import { useState } from "react";
import { useQuery } from "@apollo/client";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducers";
import { GET_OUTFITS_QUERY } from "../graphql/queries";
import ProfileHero from "../components/profile/ProfileHero";
import ProfileTabs from "../components/profile/ProfileTabs";
import ProfileContent from "../components/profile/ProfileContent";
import LoadingSpinner from "../components/profile/LoadingSpinner";
import { OutfitData } from "../types/Profile";
import { useFavoriteOutfit } from "../hooks/useFavoriteOutfit";

export default function Profile() {
  const [activeTab, setActiveTab] = useState('favourites');
  const user = useSelector((state: RootState) => state.user);
  const { toggleFavorite } = useFavoriteOutfit();
  
  const { data, loading, error } = useQuery(GET_OUTFITS_QUERY);
  
  const outfits: OutfitData[] = data?.getCurrentUser?.outfits || [];
  const favouritesCount = outfits.filter(outfit => outfit.favorited).length;
  const favouritedOutfits = outfits.filter(outfit => outfit.favorited).map(outfit => outfit.id);
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  if (error) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-light tracking-wider text-gray-900 dark:text-white">
            UNABLE TO LOAD PROFILE
          </h2>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Please try again later
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <ProfileHero 
        outfitsCount={outfits.length} 
        favouritesCount={favouritesCount} 
      />
      
      <ProfileTabs 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        outfits={outfits}
        favouritesCount={favouritesCount}
      />
      
      <ProfileContent
        activeTab={activeTab}
        outfits={outfits}
        favouritedOutfits={favouritedOutfits}
        onToggleFavourite={toggleFavorite}
      />
    </div>
  );
}